import { userGetShortName } from '@aibees/shared/utils';
import { useGetUpdatedUser } from '@aibees/shared/workspace/hooks';
import type { UserShortNameProps as Props } from './types';

export function UserShortName({ user, defaultName = '' }: Props) {
  const updated = useGetUpdatedUser(user);
  return <>{userGetShortName(updated) || defaultName}</>;
}
